export const environment = {
  production: false,
  appName: 'ALCON Productions',
  // apiBaseUrl: 'http://127.0.0.1:8000/api',
  apiBaseUrl: 'https://api.alconticket.com/api',
  useMocks: false,
  defaultLocale: 'es-GT'
};
